<template>
  <div class="tpp-page">
    <nearby-housekeeping-ops-nav active-path="/pages/tpp/nearby-housekeeping/products" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div><h2 class="tpp-panel__title">商品管理</h2><p class="tpp-muted">同步只补充众合类目、商品和规格，并绑定三方 ID。已有本地名称、说明、价格、上下架和佣金不会被覆盖。新同步内容默认下架，由这里决定是否上架。</p></div>
        <el-button type="primary" size="small" :loading="syncing" @click="syncCatalog">同步众合类目和商品</el-button>
      </div>
      <platform-product-manager v-if="platformId" ref="catalog" :platform-id="platformId" />
    </section>
  </div>
</template>
<script>
import NearbyHousekeepingOpsNav from './nearbyHousekeepingNav.vue'
import { nearbyHousekeepingOpsMixin } from './nearbyHousekeepingOpsMixin'
import PlatformProductManager from '../components/platformProductManager.vue'
import { syncNearbyHousekeepingCatalog } from '@/api/tpp/nearbyHousekeepingOpsApi'
import '../tpp.scss'
export default {
  name: 'NearbyHousekeepingProducts',
  components: { NearbyHousekeepingOpsNav, PlatformProductManager },
  mixins: [nearbyHousekeepingOpsMixin],
  data() { return { syncing: false } },
  async created() { await this.ensureNearbyHousekeepingPlatform() },
  methods: {
    async syncCatalog() {
      this.syncing = true
      try {
        const res = await syncNearbyHousekeepingCatalog({ platformId: this.platformId })
        const data = res.data || {}
        this.$message.success(`已同步 ${data.categoryCount || 0} 个类目、${data.productCount || 0} 个商品、${data.skuCount || 0} 个规格`)
        const catalog = this.$refs.catalog
        if (catalog) await Promise.all([catalog.loadCategories(), catalog.loadProducts()])
      } catch (e) { this.$message.error(e.message || '同步失败') }
      finally { this.syncing = false }
    }
  }
}
</script>
